const $slider = $('.slider-module')
const pageType = $('body').data('pagetype')
let slidesToShow = 3
if (pageType === 'article') {
    slidesToShow = 1
}
$slider.slick({
    variableWidth: true,
    infinite: false,
    slidesToShow,
    slidesToScroll: 1,
    prevArrow: `
        <button class="slick-prev" aria-label="Previous" type="button">
            <img src="/assets/img/icons/icon_dark_arrowprev@3x.svg" alt="Previous" class="dark"/>
            <img src="/assets/img/icons/icon_light_arrowprev@3x.svg" alt="Previous" class="light"/>
        </button>`,
    nextArrow: `
        <button class="slick-next" aria-label="Next" type="button">
            <img src="/assets/img/icons/icon_dark_arrownext@3x.svg" alt="Next" class="dark"/>
            <img src="/assets/img/icons/icon_light_arrownext@3x.svg" alt="Next" class="light"/>
        </button>`,
    responsive: [
        {
            breakpoint: 1105,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 725,
            settings: {
                slidesToShow: 1,
            }
        }
    ],
});

